var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrencyExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    enableBackground: "new 0 0 24 24",
    fill: "#000000",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.90678 0 0 .90678 1.1186 1.1186)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.90678 0 0 .90678 1.1186 1.1186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.89 11.1c-1.78-0.59-2.64-0.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39 1.31 0 1.79 0.99 1.9 1.34l1.58-0.67c-0.15-0.45-0.82-1.92-2.54-2.24v-1.24h-2v1.26c-2.48 0.56-2.49 2.86-2.49 2.96 0 2.27 2.25 2.91 3.35 3.31 1.58 0.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.82 0-2.34-1.87-2.4-2.09l-1.66 0.67c0.63 2.19 2.28 2.78 2.9 2.96v1.29h2v-1.24c0.4-0.09 2.9-0.59 2.9-3.22 0-1.39-0.61-2.61-3.01-3.44zm-9.89 9.9h-2v-6h6v2h-2.48c1.61 2.41 4.36 4 7.48 4 4.97 0 9-4.03 9-9h2c0 6.08-4.92 11-11 11-3.72 0-7.01-1.85-9-4.67zm-2-9c0-6.08 4.92-11 11-11 3.72 0 7.01 1.85 9 4.67v-2.67h2v6h-6v-2h2.48c-1.61-2.41-4.36-4-7.48-4-4.97 0-9 4.03-9 9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyExchange);
export default __webpack_public_path__ + "static/media/currency_exchange.892df917.svg";
export { ForwardRef as ReactComponent };